/* eslint-disable */
export function addListener(listener: object, name: string, cb: Function | string, sender?: object): string {
	return JAK.signals.addListener(listener, name, cb, sender);
}

export function removeListener(id: string): void {
	JAK.signals.removeListener(id);
}

export function removeListeners(ids: Array<string>): void {
	JAK.signals.removeListeners(ids);
}

export function makeEvent(name: string, listener: object, data: any = {}): void {
	JAK.signals.makeEvent(name, listener, data || {});
}
